import ErrorMessageComponent from './ErrorMessageComponent';
import styled from 'styled-components';

export default styled(ErrorMessageComponent)`
  .error-code {
    margin: 0 10px;
  }

  .errorMessage {
    .redeem-redirect-link {
      font-size: 1em;
    }
  }
`;
